import React from 'react';
import { articleHeadingId } from '../content/learnMetadata';

function InlineText({ text }) {
  return text.split(/(\*\*.*?\*\*)/g).map((part, index) => (
    part.startsWith('**') && part.endsWith('**')
      ? <strong key={index}>{part.slice(2, -2)}</strong>
      : part
  ));
}

export default function ArticleContent({ blocks }) {
  return blocks.map((block, index) => {
    if (block.type === 'link') {
      return <p key={index}><a href={block.href}>{block.text}</a></p>;
    }
    if (block.type === 'table') {
      return (
        <div className="learn-article__table" key={index}>
          <table>
            <thead><tr>{block.headers.map((header) => <th scope="col" key={header}>{header}</th>)}</tr></thead>
            <tbody>{block.rows.map((row, rowIndex) => (
              <tr key={rowIndex}>{row.map((cell, cellIndex) => <td key={cellIndex}><InlineText text={cell} /></td>)}</tr>
            ))}</tbody>
          </table>
        </div>
      );
    }
    if (block.type === 'ul' || block.type === 'ol') {
      const List = block.type;
      return <List key={index}>{block.items.map((item) => <li key={item}><InlineText text={item} /></li>)}</List>;
    }
    const Tag = block.type;
    return <Tag key={index} id={block.type === 'h2' ? articleHeadingId(block.text) : undefined}><InlineText text={block.text} /></Tag>;
  });
}
